import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

import { fetchEnumValues } from '@services/commonService';

const Certificate = ({ isDependentFilter }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	const onFetchData = async () => {
		let responseData = isDependentFilter
			? dependentFilterList?.certificateTypeList
			: await fetchEnumValues('info.nitex.app.supplier.CertificateType');
		responseData = responseData?.map((item) => {
			return { id: item.constant, name: item.name };
		});
		setAllData(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allData?.filter((item) => item?.name?.toLowerCase().includes(e.target.value.toLowerCase()))
			: allData;
		setData(searchResult);
	};
	return (
		<>
			<FilterName type="CERTIFICATE" />
			<Checkbox data={data} type="CERTIFICATE" handleSearch={handleSearch} />
		</>
	);
};

export default Certificate;
